import * as React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { MHColours } from '../../constants/theme';

export type Severity = 'success' | 'warning' | 'error';

export interface FlashProps {
  open: boolean;
  msg: string;
  severity?: Severity;

  autoHideFor?: Severity[];

  autoHideMs?: number;
  onClose: () => void;
}

const FlashSnackbar: React.FC<FlashProps> = ({
  open,
  msg,
  severity = 'success',
  autoHideFor = ['success'],
  autoHideMs = 5000,
  onClose,
}) => {
  const shouldAutoHide = autoHideFor.includes(severity);
  return (
    <Snackbar
      open={open}
      autoHideDuration={shouldAutoHide ? autoHideMs : undefined}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{
          width: '100%',
          ...(severity === 'success' && {
            backgroundColor: MHColours.mhDeepTeal,
          }),
        }}
      >
        {msg}
      </Alert>
    </Snackbar>
  );
};

export default FlashSnackbar;
